//按需加载
import { editDemolitionBlock } from "../../../../api/api";

export default {
  data() {
    return {
      form: {
        projectId: 0, //项目id
        areaId: 0, //区域ID
        code: "", //编号
        section: "", //标段信息
        community: "", //所属集体
        holder: "", //权益人
        feature: "", //特征
        amount: "", //金额(元)
        area: "", //面积(亩)
        type: "", //类型
        status: 0, // 征拆状态: 0:已完成；1:未完成
        completionDate: "", //日期
        remarks: "", //备注
        isOutOfBound: 0, // 是否越界: 0:未越界；1:已越界
        excessArea: "", //超征面积(亩)
      },
      initialForm: {
        projectId: 0, //项目id
        areaId: 0, //区域ID
        code: "", //编号
        section: "", //标段信息
        community: "", //所属集体
        holder: "", //权益人
        feature: "", //特征
        amount: "", //金额(元)
        area: "", //面积(亩)
        type: "", //类型
        status: 0, // 征拆状态: 0:已完成；1:未完成
        completionDate: "", //日期
        remarks: "", //备注
        isOutOfBound: 0, // 是否越界: 0:未越界；1:已越界
        excessArea: "", //超征面积(亩)
      }, //考虑到数据量比较到就不做重新加载 这里保存对象真实属性
      loading: true,
      options: [],
    };
  },
  mounted() {},
  methods: {
    demolitionInfoModifyBox_close() {
      this.$emit("demolitionInfoModify_close");
    },
    downloadAquisitionDetail() {},
    uploadFile() {},
    getCurrentRow(index, row) {},
    handleCurrentChange(val) {
      this.currentPage = val;
      //this.initData();
      console.log(`当前页: ${val}`);
    },
    save() {
      this.loading = true;
      editDemolitionBlock(this.form)
        .then((res) => {
          // console.log(JSON.parse(JSON.stringify(res)));
          // console.log(444444444444);
          if (res.data.success && res.data.code === 204) {
            // that.initTreeData(); //请求后台数据刷新
            //this.$refs.bimDemolitionTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。
            //同时还要关闭第二个弹窗，避免已删除的信息的编辑弹窗还在。
            let {
              code,
              section,
              community,
              holder,
              feature,
              amount,
              area,
              type,
              status,
              completionDate,
              remarks,
              isOutOfBound,
              excessArea,
            } = this.form;
            this.initialForm.code = code;
            this.initialForm.section = section;
            this.initialForm.community = community;
            this.initialForm.holder = holder;
            this.initialForm.feature = feature;
            this.initialForm.amount = amount;
            this.initialForm.area = area;
            this.initialForm.type = type;
            this.initialForm.status = status;
            this.initialForm.completionDate = completionDate;
            this.initialForm.remarks = remarks;
            this.initialForm.isOutOfBound = isOutOfBound;
            this.initialForm.excessArea = excessArea;

            this.$notify({
              title: "已成功编辑该区域。",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          } else {
            this.$alert("编辑该区域失败了，请再试一次吧~", "删除失败", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
          }
          this.open_demolition_box = "";
          this.loading = false;
        })
        .catch((res) => {
          this.$alert("编辑该区域失败了，请再试一次吧~", "删除失败", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        });
      this.$emit("demolitionInfoModify_close");
    },
    cancel() {
      this.$emit("demolitionInfoModify_close");
    },
  },
  watch: {},
  destroyed() {},
};
